import { BrandIcon } from '@/components/BrandIcon'
import { Spinner } from '@/components/ui/Spinner'

export function AppLoadingScreen({ message }: { message?: string }) {
  return (
    <div className="flex h-full items-center justify-center bg-canvas">
      <div className="flex max-w-[280px] flex-col items-center">
        <BrandIcon size={96} />
        <p className="mt-6 text-xl font-bold text-ink">KHANQ Admin</p>
        <Spinner size={28} className="mt-8 text-brand" />
        {message ? <p className="mt-4 text-center text-sm text-ink-muted">{message}</p> : null}
      </div>
    </div>
  )
}
